import script from "./MonthlyContentManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyContentManagement.vue?vue&type=script&setup=true&lang=js"

import "./MonthlyContentManagement.vue?vue&type=style&index=0&id=abdb5baa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abdb5baa"]])

export default __exports__